module.exports = __webpack_public_path__ + "static/media/edit.f7ea4cca.svg";